'use client';

import { BudgetCalculatorForm } from './BudgetCalculatorForm';
import { DISCLAIMER } from './constants';

export const BudgetCalculator = () => (
  <div className="rounded-xl bg-bg-raised-secondary p-6 font-sans sm:p-10">
    <BudgetCalculatorForm />
    <p className="mt-8 text-legal">{DISCLAIMER}</p>
  </div>
);
